<template>
    <div class="followup-lock-toast">
        <div class="toast-header-row">
            <i class="fa fa-lock"></i>
            <strong>Patient In Use</strong>
        </div>
        <p class="toast-message">Someone is already following up with this patient. If you believe this is an error, you can release the lock.</p>
        <div class="toast-actions">
            <b-button variant="light" size="sm" @click="clearFollowupCache">
                <i class="fa fa-unlock"></i> Release Lock
            </b-button>
        </div>
    </div>
</template>

<script>
import store from '@/store';

export default {
    name: 'ToastComponent',
    props: ['payload'],

    data() {
        return {
            releasing: false
        }
    },

    methods: {
        async clearFollowupCache() {
            if (this.releasing) return;
            this.releasing = true;

            // Validate payload has required properties
            if (!this.payload || !this.payload.cacheName || !this.payload.cacheSet || !this.payload.element) {
                this.$toast.error('Unable to release lock: invalid session data.');
                this.releasing = false;
                return;
            }

            try {
                await store.dispatch('cache/removeValueFromSet', this.payload);
                this.$toast.success('Lock released. You can now follow up with this patient.');
            } catch (error) {
                console.error('Error releasing lock:', error);
                this.$toast.error('Failed to release lock. Please try again.');
            } finally {
                this.releasing = false;
            }
        }
    }
}
</script>

<style scoped>
.followup-lock-toast {
    padding: 0.25rem 0;
}

.toast-header-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.toast-header-row i {
    font-size: 1rem;
}

.toast-header-row strong {
    font-size: 0.9375rem;
}

.toast-message {
    font-size: 0.8125rem;
    margin: 0 0 0.75rem 0;
    opacity: 0.95;
    line-height: 1.4;
}

.toast-actions {
    display: flex;
    gap: 0.5rem;
}

.toast-actions .btn {
    font-size: 0.75rem;
    padding: 0.25rem 0.625rem;
}
</style>
